import useBasket from '@/hooks/useBasket'

// Hooks
const { basket } = useBasket()

function getPersonsByMutability(persons) {
  const { existingCustomer } = basket
  if (!existingCustomer) {
    return {
      mutable: persons,
      immutable: []
    }
  }

  return persons.reduce((prev, curr) => {
    prev[curr.contractModified ? 'mutable' : 'immutable'].push(curr)
    return prev
  }, { mutable: [], immutable: []})
}

export default function useExistingCustomer() {
  return {
    getPersonsByMutability,
  }
}
